import * as React from 'react';
import MediaQuery from 'react-responsive';
import Badge from '@telia-front/badge';
import { useIsMounted } from '@telia-front/helper';
import Icon from '@telia-front/icon';
import { useTheme } from '@telia-front/theme-provider';
const ProgressItem = (props) => {
    const isMounted = useIsMounted();
    const { media } = useTheme();
    const BEM = () => {
        const classArray = ['progress__item'];
        if (props.state) {
            classArray.push(`is-${props.state}`);
        }
        if (props.error) {
            classArray.push('is-invalid');
        }
        if (props.icon) {
            classArray.push('has-icon');
        }
        if (props.subItems) {
            classArray.push('has-subitems');
        }
        if (props.uncategorized) {
            classArray.push('progress__item--uncategorized');
        }
        if (props.purpose) {
            classArray.push(`progress__item--${props.purpose}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const subItemBEM = (item) => {
        const classArray = ['progress__sub-item'];
        if (item.state) {
            classArray.push('is-' + item.state);
        }
        if (item.purpose) {
            classArray.push(`progress__sub-item--${item.purpose}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const getBreakpoint = (breakPoint) => {
        return media.width[breakPoint].min;
    };
    const getContent = () => {
        if (props.isBottom || !isMounted) {
            return null;
        }
        if (props.break) {
            return React.createElement(MediaQuery, { minWidth: getBreakpoint(props.break) }, (matches) => setContent(matches));
        }
        else {
            return setContent(false);
        }
    };
    const getSubItems = () => {
        if (props.subItems) {
            const subItems = props.subItems.map((subItem, index) => {
                const ProgressSubItemButtonTag = subItem.onClick ? 'button' : 'div';
                return (React.createElement("li", { key: index, className: subItemBEM(subItem) },
                    React.createElement(ProgressSubItemButtonTag, { type: subItem.onClick ? 'button' : undefined, className: "progress__header", onClick: subItem.onClick },
                        React.createElement("span", { className: "progress__sub-header-inner" },
                            React.createElement("span", { className: "progress__header-title-section" },
                                React.createElement("span", { className: "progress__sub-title" },
                                    subItem.title,
                                    subItem.state === 'done' && React.createElement(Badge, { icon: "#check", size: "small", purpose: "success", className: "progress__sub-badge" })),
                                subItem.info && React.createElement("span", { className: "text-small" }, subItem.info)),
                            subItem.price && getMetaContent(subItem)))));
            });
            return React.createElement("ul", { className: "progress__sub-steps" }, subItems);
        }
    };
    const setContent = (matches) => {
        if (!matches) {
            return React.createElement("div", { className: "progress__content" }, props.children);
        }
        else {
            return null;
        }
    };
    const getIcon = () => {
        if (props.icon && props.state !== 'done') {
            return props.icon;
        }
        if (props.state === 'done') {
            return '#check';
        }
        if (props.error) {
            return '#alert';
        }
    };
    const getMetaContent = (subItem) => {
        const price = subItem ? subItem.price : props.price;
        const subPrice = subItem ? subItem.subPrice : props.subPrice;
        return (React.createElement("span", { className: "progress__header-meta-section" },
            React.createElement("span", null, price),
            React.createElement("br", null),
            subPrice && (React.createElement("span", { className: "text-light text-small" },
                React.createElement("del", null, subPrice)))));
    };
    const getBadgeIconOrText = () => {
        const { index } = props;
        const icon = getIcon();
        return icon ? { icon } : { text: index || '' };
    };
    const getBadgePurpose = () => {
        const { state, error, purpose } = props;
        if (error) {
            return 'error';
        }
        else if (purpose === 'employee' && state === 'done') {
            return 'employee';
        }
        else if (purpose === 'employee' && state === 'current') {
            return 'employee-active';
        }
        else if (purpose === 'employee' && state === 'disabled') {
            return 'employee';
        }
        else if (state === 'done') {
            return 'success';
        }
        else if (state === 'current') {
            return 'selected';
        }
        return 'inactive';
    };
    const renderBadgeOrIcon = () => {
        const { state, style } = props;
        const icon = getIcon();
        if (icon && state === 'disabled' && style === 'card') {
            return React.createElement(Icon, { modifiers: icon, className: "progress__icon" });
        }
        return React.createElement(Badge, Object.assign({}, getBadgeIconOrText(), { className: "progress__badge", purpose: getBadgePurpose(), size: "large", responsiveSize: true, width: "fixed" }));
    };
    const ProgressItemButtonTag = props.onClick ? 'button' : 'div';
    return (React.createElement("li", { className: BEM() },
        React.createElement(ProgressItemButtonTag, { className: "progress__header", onClick: props.onClick, type: props.onClick ? 'button' : undefined },
            React.createElement("span", { className: "progress__counter" }, renderBadgeOrIcon()),
            React.createElement("span", { className: "progress__header-inner" },
                React.createElement("span", { className: "progress__header-title-section" },
                    React.createElement("span", { className: "progress__title" }, props.title),
                    props.info && React.createElement("span", { className: "progress__info" }, props.info),
                    props.error && React.createElement("span", { className: "progress__error" }, props.error)),
                props.price && getMetaContent())),
        props.children && props.state === 'current' && props.style !== 'card' && getContent(),
        props.subItems && getSubItems()));
};
export default ProgressItem;
